import React from "react";
import EnhancedHiringPipeline from "./EnhancedHiringPipeline";

const HiringPipeline = () => {
    // Redirect to enhanced version with real data integration
    return <EnhancedHiringPipeline />;
};

export default HiringPipeline;